function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Beginning-of-creation-flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Updated-collection-template-",
  transform: "translate(-409.000000, -204.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "graphic",
  transform: "translate(409.000000, 204.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19,0 L19,39 C8.50658975,39 0,30.2695526 0,19.5 C0,8.73044738 8.50658975,0 19,0 L19,0 Z",
  id: "Combined-Shape",
  fill: "#D1E3E3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33,18 L33,57 C21.954305,57 13,48.2695526 13,37.5 C13,26.7304474 21.954305,18 33,18 L33,18 Z",
  id: "Combined-Shape-Copy",
  fillOpacity: 0.6,
  fill: "#8C837B",
  transform: "translate(23.000000, 37.500000) scale(-1, 1) translate(-23.000000, -37.500000) "
}))));

function SvgIconComingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "57px",
    viewBox: "0 0 33 57",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComingSoon);
export default __webpack_public_path__ + "static/media/icon_coming_soon.467802f3.svg";
export { ForwardRef as ReactComponent };